import { useContext } from 'react'
import { useLocation } from 'react-router-dom'

import { DateTime } from 'luxon'

import {
  Box, Columns, Form, LoadingModule, Text,
} from '@domain-group/suit-theme'

import PackContext from '@contexts/packContext'

import usePublicationEditionsDeadlines from '@hooks/usePublicationEditionDeadlines'
import type { FilterOptions } from '@hooks/usePublicationEditionDeadlines'

import DeadlinesListItem from './DeadlinesListItem'

const days: string[] = []

for (let i = 0; i <= 6; i += 1){
  const day = DateTime.now().plus({ days: i })
  days.push(day.weekdayLong)
}

const NewsDeskSidebarDeadlines = (props: { pageFilters: FilterOptions }) => {
  const { pageFilters } = props
  const { days_from_now } = pageFilters

  useLocation()

  const packContext = useContext(PackContext)
  const {
    callbacks: {
      updateFilters,
    },
  } = packContext

  // add filter for unused deadlines
  const publicationEditionDeadlinesPayload = usePublicationEditionsDeadlines({
    filters: { days_from_now, include_unused_editions: false },
    requestOptions: {
      include_publication_edition_deadlines: true,
      include_publication_edition_order_item_count: true,
      include_publication_edition_publication: true,
    },
    performHttpRequests: true,
  })

  const {
    loading, filteredPublicationEditionDeadlines, hasFilteredPublicationEditionDeadlines,
  } = publicationEditionDeadlinesPayload

  return (
    <Box paddingX="large">
      <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'column']}>
        <Form.Field label="Showing Deadlines For">
          <select
            name="days_from_now"
            value={days_from_now}
            onChange={e => updateFilters({ ...pageFilters, days_from_now: e.target.value })}
          >
            {days.map((day, i) => (
              <option value={i}>{i === 0 ? 'Today' : day}</option>
            ))}
          </select>
        </Form.Field>

        <LoadingModule boxProps={{ marginTop: 'large' }} loading={loading} times={1} />

        {!loading && filteredPublicationEditionDeadlines.map(deadline => (
          <DeadlinesListItem deadline={deadline} pageFilters={pageFilters} updateFilters={updateFilters} />
        ))}

        {!loading && !hasFilteredPublicationEditionDeadlines && (
          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="large">No Deadlines Present</Text>
        )}
      </Columns>
    </Box>
  )
}

export default NewsDeskSidebarDeadlines
